import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "p-8" }
const _hoisted_2 = { class: "flex items-center justify-between border-b border-gray-200 pb-6 mb-6" }
const _hoisted_3 = { class: "text-2xl font-semibold text-gray-800" }
const _hoisted_4 = {
  key: 0,
  class: "text-slate-500"
}
const _hoisted_5 = {
  key: 0,
  class: "text-sm text-gray-600 mt-2"
}
const _hoisted_6 = { class: "flex gap-3" }
const _hoisted_7 = {
  key: 0,
  class: "mb-6"
}
const _hoisted_8 = { class: "relative max-w-md" }
const _hoisted_9 = {
  key: 0,
  class: "text-sm text-gray-600 mt-2"
}
const _hoisted_10 = {
  key: 1,
  class: "flex flex-col items-center justify-center py-20"
}
const _hoisted_11 = {
  key: 2,
  class: "flex flex-col items-center justify-center py-20"
}
const _hoisted_12 = { class: "bg-red-50 border border-red-200 rounded-lg p-6 max-w-md" }
const _hoisted_13 = { class: "text-red-700 text-sm mb-4" }
const _hoisted_14 = {
  key: 3,
  class: "fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
}
const _hoisted_15 = { class: "bg-white rounded-lg p-8 max-w-md shadow-2xl" }
const _hoisted_16 = { class: "flex flex-col items-center" }
const _hoisted_17 = { class: "text-gray-600 text-center mb-4" }
const _hoisted_18 = {
  key: 0,
  class: "flex items-center justify-center py-12"
}
const _hoisted_19 = {
  key: 1,
  class: "bg-red-50 border border-red-200 rounded-lg p-4"
}
const _hoisted_20 = { class: "text-red-700 text-sm" }
const _hoisted_21 = {
  key: 2,
  class: "space-y-4"
}
const _hoisted_22 = { class: "mt-6 border-t pt-4" }
const _hoisted_23 = {
  key: 3,
  class: "flex items-center justify-center py-8"
}
const _hoisted_24 = {
  key: 5,
  class: "space-y-4"
}
const _hoisted_25 = { class: "border rounded-lg overflow-hidden bg-white shadow-sm" }
const _hoisted_26 = { class: "overflow-x-auto" }
const _hoisted_27 = { class: "w-full" }
const _hoisted_28 = { class: "bg-gray-50 border-b" }
const _hoisted_29 = { class: "w-12 px-4 py-3 text-left" }
const _hoisted_30 = ["checked", ".indeterminate", "disabled"]
const _hoisted_31 = { class: "divide-y divide-gray-200" }
const _hoisted_32 = { class: "px-4 py-3" }
const _hoisted_33 = ["checked", "onChange", "disabled"]
const _hoisted_34 = { class: "px-4 py-3" }
const _hoisted_35 = { class: "inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-slate-200 text-[#255f7a]" }
const _hoisted_36 = { class: "px-4 py-3" }
const _hoisted_37 = { class: "text-sm text-gray-900 font-medium" }
const _hoisted_38 = { class: "block text-gray-500" }
const _hoisted_39 = { class: "px-4 py-3" }
const _hoisted_40 = { class: "text-sm font-mono text-gray-700" }
const _hoisted_41 = { class: "px-4 py-3" }
const _hoisted_42 = { class: "text-sm font-mono text-gray-700" }
const _hoisted_43 = { class: "px-4 py-3" }
const _hoisted_44 = { class: "text-sm font-mono text-gray-700" }
const _hoisted_45 = { class: "px-4 py-3" }
const _hoisted_46 = { class: "inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-gray-100 text-gray-800" }
const _hoisted_47 = { class: "px-4 py-3" }
const _hoisted_48 = { class: "inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-gray-100 text-gray-800" }
const _hoisted_49 = { class: "px-4 py-3" }
const _hoisted_50 = { class: "text-sm" }
const _hoisted_51 = { class: "text-gray-900" }
const _hoisted_52 = { class: "text-gray-500 text-xs" }
const _hoisted_53 = { class: "px-4 py-3" }
const _hoisted_54 = { class: "flex items-center gap-1 text-sm text-gray-700" }
const _hoisted_55 = { class: "px-4 py-3" }
const _hoisted_56 = { class: "flex flex-wrap gap-1" }
const _hoisted_57 = { class: "px-4 py-3" }
const _hoisted_58 = ["onClick"]
const _hoisted_59 = { class: "flex items-center justify-between px-4 py-3 bg-white border rounded-lg" }
const _hoisted_60 = { class: "text-sm text-gray-700" }
const _hoisted_61 = { class: "flex items-center gap-2" }
const _hoisted_62 = { class: "flex gap-1" }
const _hoisted_63 = {
  key: 6,
  class: "flex flex-col items-center justify-center py-20"
}
const _hoisted_64 = { class: "text-lg font-semibold text-gray-700 mb-2" }
const _hoisted_65 = { class: "text-gray-500 text-sm mb-4" }

import TreatmentPlanDetail from '@/components/common/TreatmentPlanDetail.vue';
import { Button } from '@/components/ui/button';
import {
    Dialog,
    DialogContent,
    DialogHeader,
    DialogTitle
} from '@/components/ui/dialog';
import { Input } from '@/components/ui/input';
import {
    fetchTreatmentPlan,
    useStageTariffCodeRollover,
    useTariffCodesRollover
} from '@/hooks/use-treatment-plans';
import { useRolloverStore } from '@/store/use-rollover-store';
import { showError, showSuccess } from '@/utils/toast';
import PreviewResultsDialog from '@/views/tools/previews/PreviewResultsDialog.vue';
import {
    ArrowRight,
    ChevronLeft,
    ChevronRight,
    Eye,
    RepeatIcon,
    Search
} from 'lucide-vue-next';
import { storeToRefs } from 'pinia';
import { computed, ref } from 'vue';
import { useRouter } from 'vue-router';

interface RolloverData {
  membership_number?: string
  option_code?: string
  scheme_code?: string
  dependant_code?: string
  auth_start_date?: string
  auth_end_date: string
  sunset: string
  to_year: string
  tariff_codes: string[]
}

// Form inputs

export default /*@__PURE__*/_defineComponent({
  __name: 'RolloverStagingView',
  emits: ["update:open"],
  setup(__props, { emit: __emit }) {

const router = useRouter();

const status = ref('enrolled')
const programmePhaseId = ref('1')
const toYear = ref('2026')
const sunset = ref('2025')

// Search and pagination
const searchQuery = ref('')
const currentPage = ref(1)
const itemsPerPage = ref(15)

// Treatment plan dialog
const isDialogOpen = ref(false)
const selectedRow = ref<RolloverData | null>(null)
const fetchedTreatmentPlan = ref<any>(null)
const isFetchingTreatmentPlan = ref(false)
const treatmentPlanError = ref<string | null>(null)

// Open treatment plan dialog
const openTreatmentPlanDialog = async (item: RolloverData) => {
  selectedRow.value = item
  isDialogOpen.value = true
  isFetchingTreatmentPlan.value = true
  treatmentPlanError.value = null
  fetchedTreatmentPlan.value = null
  
  try {
    const payload = {
      scheme_code: item?.scheme_code,
      membership_number: item?.membership_number,
      dependant_code: item?.dependant_code,
      option_code: item?.option_code,
      auth_start_date: item?.auth_start_date
    }
    
    // Fetch the data
    const tp = await fetchTreatmentPlan(payload)
    console.log(`Fetched Treatment Plan:`, tp)
    fetchedTreatmentPlan.value = tp
  } catch (err: any) {
    console.error('Error fetching treatment plan:', err)
    treatmentPlanError.value = err?.message || 'Failed to load treatment plan'
  } finally {
    isFetchingTreatmentPlan.value = false
  }
}

// Close treatment plan dialog
const closeTreatmentPlanDialog = () => {
  isDialogOpen.value = false
  selectedRow.value = null
  fetchedTreatmentPlan.value = null
  treatmentPlanError.value = null
}
// USE QUERY TO STAGE ROLLOVER
const { 
  data, 
  isLoading, 
  isError, 
  error, 
  refetch 
} = useStageTariffCodeRollover(
  status.value,
  programmePhaseId.value,
  toYear.value,
  sunset.value
)

const { mutate: rollover, isPending } = useTariffCodesRollover()

// Get store
const rolloverStore = useRolloverStore()

const emit = __emit

// Destructure state with storeToRefs
const { rolloverResults, rolloverDataList } = storeToRefs(rolloverStore)

// Filtered data based on search
const filteredData = computed(() => {
  if (!data.value) return []
  
  const query = searchQuery.value.toLowerCase().trim()
  if (!query) return data.value
  
  return data.value.filter((item: RolloverData) => 
    item.scheme_code?.toLowerCase().includes(query) ||
    item.option_code?.toLowerCase().includes(query) ||
    item.membership_number?.toLowerCase().includes(query)
  )
})

// Pagination
const totalPages = computed(() => Math.ceil(filteredData.value.length / itemsPerPage.value))

const paginatedData = computed(() => {
  const start = (currentPage.value - 1) * itemsPerPage.value
  const end = start + itemsPerPage.value
  return filteredData.value.slice(start, end)
})

const goToPage = (page: number) => {
  if (page >= 1 && page <= totalPages.value) {
    currentPage.value = page
  }
}

// Reset to page 1 when search changes
const handleSearch = () => {
  currentPage.value = 1
}

// Computed property for safe access
const hasResults = computed(() => rolloverResults.value !== null)
const selectedCount = computed(() => rolloverDataList.value.length)

const isResultDialogOpen = ref(false)

// Check if all visible items are selected
const isAllSelected = computed(() => {
  if (paginatedData.value.length === 0) return false
  return paginatedData.value.every(item => isSelected(item))
})

// Check if some (but not all) visible items are selected
const isIndeterminate = computed(() => {
  const selectedInPage = paginatedData.value.filter(item => isSelected(item)).length
  return selectedInPage > 0 && selectedInPage < paginatedData.value.length
})

// Check if item is selected
const isSelected = (item: RolloverData) => {
  return rolloverDataList.value.some(
    selected => selected.membership_number === item.membership_number
  )
}

// Toggle selection
const toggleSelection = (item: RolloverData) => {
  if (isSelected(item)) {
    rolloverStore.removeRolloverDataByMembership(item.membership_number!)
  } else {
    rolloverStore.setRolloverDataList(item)
  }
}

// Toggle all visible items
const toggleAll = () => {
  if (isAllSelected.value) {
    // Deselect all visible items
    paginatedData.value.forEach(item => {
      if (isSelected(item)) {
        rolloverStore.removeRolloverDataByMembership(item.membership_number!)
      }
    })
  } else {
    // Select all visible items
    paginatedData.value.forEach(item => {
      if (!isSelected(item)) {
        rolloverStore.setRolloverDataList(item)
      }
    })
  }
}

const handleClose = () => {
  emit('update:open', false)
  rolloverStore.clearRolloverDataList()
  rolloverStore.clearRolloverData()
}

// Bulk rollover selected items
const handleBulkRollover = () => {
  if (selectedCount.value === 0) {
    showError('Please select at least one item')
    return
  }
  
  rollover({
    sunset: '2025',
    toYear: '2026',
    // @ts-ignore [TODO]
    payload: rolloverDataList.value
  }, {
    onSuccess: (data) => {
      showSuccess("Rollover completed!");
      rolloverStore.setRolloverResults(data)
      handleClose()
      isResultDialogOpen.value = true
    },
    onError: (error: any) => {
      showError(error.message || 'An error occurred during rollover');
    }
  })
}

if (hasResults) {
  isResultDialogOpen.value = true
}

// Clear all selections
const clearAllSelections = () => {
  rolloverStore.clearRolloverDataList()
}

const toTransactions = () => {
  router.push("/transactions")
}


return (_ctx: any,_cache: any) => {
  const _component_DialogDescription = _resolveComponent("DialogDescription")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _createElementVNode("h2", _hoisted_3, [
          _cache[9] || (_cache[9] = _createTextVNode(" Rollover - Eligible Health Seekers ", -1)),
          (_unref(data)?.length > 0)
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, "(" + _toDisplayString(_unref(data)?.length) + ")", 1))
            : _createCommentVNode("", true)
        ]),
        (selectedCount.value > 0)
          ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(selectedCount.value) + " item(s) selected ", 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_6, [
        (selectedCount.value > 0)
          ? (_openBlock(), _createBlock(_unref(Button), {
              key: 0,
              size: "sm",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (clearAllSelections())),
              variant: "outline",
              disabled: _unref(isPending),
              class: "text-red-600 bg-red-50 hover:bg-red-600 hover:text-white"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" CLEAR ALL (" + _toDisplayString(selectedCount.value) + ") ", 1)
              ]),
              _: 1
            }, 8, ["disabled"]))
          : _createCommentVNode("", true),
        _createVNode(_unref(Button), {
          size: "sm",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (handleBulkRollover())),
          disabled: selectedCount.value === 0 || _unref(isPending),
          class: "bg-[#225f7a] text-white hover:bg-green-800"
        }, {
          default: _withCtx(() => [
            _createTextVNode(" BULK ROLLOVER (" + _toDisplayString(selectedCount.value) + ") ", 1),
            _createVNode(_unref(ArrowRight), { class: "ml-2 h-4 w-4" })
          ]),
          _: 1
        }, 8, ["disabled"])
      ])
    ]),
    (!_unref(isLoading) && !_unref(isError) && _unref(data)?.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_unref(Search), { class: "absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-gray-400" }),
            _createVNode(_unref(Input), {
              modelValue: searchQuery.value,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((searchQuery).value = $event)),
              onInput: handleSearch,
              placeholder: "Search by scheme, option, or membership number...",
              class: "pl-10"
            }, null, 8, ["modelValue"])
          ]),
          (searchQuery.value)
            ? (_openBlock(), _createElementBlock("p", _hoisted_9, " Found " + _toDisplayString(filteredData.value.length) + " result(s) ", 1))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_unref(isLoading))
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [...(_cache[10] || (_cache[10] = [
          _createElementVNode("div", { class: "animate-spin rounded-full h-12 w-12 border-b-2 border-slate-600 mb-4" }, null, -1),
          _createElementVNode("p", { class: "text-lg text-gray-600 font-medium" }, "Loading eligible health seekers...", -1)
        ]))]))
      : (_unref(isError))
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _cache[12] || (_cache[12] = _createElementVNode("h3", { class: "text-lg font-semibold text-red-900 mb-3" }, "Error Loading Data", -1)),
              _createElementVNode("p", _hoisted_13, _toDisplayString(_unref(error)?.message), 1),
              _createVNode(_unref(Button), {
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(refetch)())),
                variant: "outline",
                class: "w-full border-red-600 text-red-600 hover:bg-red-600 hover:text-white"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(RepeatIcon), { class: "mr-2 h-4 w-4" }),
                  _cache[11] || (_cache[11] = _createTextVNode(" Try Again ", -1))
                ]),
                _: 1
              })
            ])
          ]))
        : _createCommentVNode("", true),
    (_unref(isPending))
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _cache[13] || (_cache[13] = _createElementVNode("div", { class: "animate-spin rounded-full h-12 w-12 border-b-2 border-slate-600 mb-4" }, null, -1)),
              _cache[14] || (_cache[14] = _createElementVNode("h3", { class: "text-xl font-semibold text-gray-900 mb-2" }, "Processing Rollover", -1)),
              _createElementVNode("p", _hoisted_17, " Please wait while we process " + _toDisplayString(selectedCount.value) + " health seeker(s)... ", 1)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (hasResults.value && isResultDialogOpen.value && _unref(rolloverResults))
      ? (_openBlock(), _createBlock(PreviewResultsDialog, {
          key: 4,
          open: isResultDialogOpen.value,
          "onUpdate:open": _cache[4] || (_cache[4] = ($event: any) => ((isResultDialogOpen).value = $event)),
          response: [_unref(rolloverResults)]
        }, null, 8, ["open", "response"]))
      : _createCommentVNode("", true),
    _createVNode(_unref(Dialog), {
      open: isDialogOpen.value,
      "onUpdate:open": closeTreatmentPlanDialog
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(DialogContent), { class: "w-[80vw] max-w-none sm:max-w-none bg-slate-100 overflow-y-auto max-h-[90vh]" }, {
          default: _withCtx(() => [
            _createVNode(_unref(DialogHeader), null, {
              default: _withCtx(() => [
                _createVNode(_unref(DialogTitle), null, {
                  default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                    _createTextVNode("Treatment Plan Details", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_DialogDescription, null, {
                  default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                    _createTextVNode(" Transaction data as received from the health insurance scheme. ", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _: 1
            }),
            (isFetchingTreatmentPlan.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_18, [...(_cache[17] || (_cache[17] = [
                  _createElementVNode("div", { class: "flex flex-col items-center" }, [
                    _createElementVNode("div", { class: "animate-spin rounded-full h-8 w-8 border-b-2 border-slate-600 mb-3" }),
                    _createElementVNode("p", { class: "text-gray-600" }, "Loading treatment plan...")
                  ], -1)
                ]))]))
              : (treatmentPlanError.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                    _createElementVNode("p", _hoisted_20, _toDisplayString(treatmentPlanError.value), 1)
                  ]))
                : (selectedRow.value && fetchedTreatmentPlan.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                      _createElementVNode("div", _hoisted_22, [
                        _cache[18] || (_cache[18] = _createElementVNode("p", { class: "text-xs font-semibold text-gray-600 uppercase mb-3" }, "Treatment Plan", -1)),
                        _createVNode(TreatmentPlanDetail, { data: fetchedTreatmentPlan.value }, null, 8, ["data"])
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_23, [...(_cache[19] || (_cache[19] = [
                      _createElementVNode("p", { class: "text-gray-600" }, "No treatment plan data available", -1)
                    ]))]))
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["open"]),
    (!_unref(isLoading) && !_unref(isError) && filteredData.value.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("table", _hoisted_27, [
                _createElementVNode("thead", _hoisted_28, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", _hoisted_29, [
                      _createElementVNode("input", {
                        type: "checkbox",
                        checked: isAllSelected.value,
                        ".indeterminate": isIndeterminate.value,
                        onChange: toggleAll,
                        disabled: _unref(isPending),
                        class: "w-4 h-4 rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                      }, null, 40, _hoisted_30)
                    ]),
                    _cache[20] || (_cache[20] = _createElementVNode("th", { class: "px-4 py-3 text-left text-xs font-medium text-gray-700 uppercase" }, " Scheme ", -1)),
                    _cache[21] || (_cache[21] = _createElementVNode("th", { class: "px-4 py-3 text-left text-xs font-medium text-gray-700 uppercase" }, " Option ", -1)),
                    _cache[22] || (_cache[22] = _createElementVNode("th", { class: "px-4 py-3 text-left text-xs font-medium text-gray-700 uppercase" }, " Membership Number ", -1)),
                    _cache[23] || (_cache[23] = _createElementVNode("th", { class: "px-4 py-3 text-left text-xs font-medium text-gray-700 uppercase" }, " Names ", -1)),
                    _cache[24] || (_cache[24] = _createElementVNode("th", { class: "px-4 py-3 text-left text-xs font-medium text-gray-700 uppercase" }, " Surname ", -1)),
                    _cache[25] || (_cache[25] = _createElementVNode("th", { class: "px-4 py-3 text-left text-xs font-medium text-gray-700 uppercase" }, " Dependant ", -1)),
                    _cache[26] || (_cache[26] = _createElementVNode("th", { class: "px-4 py-3 text-left text-xs font-medium text-gray-700 uppercase" }, " Phase ", -1)),
                    _cache[27] || (_cache[27] = _createElementVNode("th", { class: "px-4 py-3 text-left text-xs font-medium text-gray-700 uppercase" }, " Auth Period ", -1)),
                    _cache[28] || (_cache[28] = _createElementVNode("th", { class: "px-4 py-3 text-left text-xs font-medium text-gray-700 uppercase" }, " Rollover ", -1)),
                    _cache[29] || (_cache[29] = _createElementVNode("th", { class: "px-4 py-3 text-left text-xs font-medium text-gray-700 uppercase" }, " Tariff Codes ", -1)),
                    _cache[30] || (_cache[30] = _createElementVNode("th", { class: "px-4 py-3 text-left text-xs font-medium text-gray-700 uppercase" }, " View ", -1))
                  ])
                ]),
                _createElementVNode("tbody", _hoisted_31, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paginatedData.value, (item, index) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: index,
                      class: _normalizeClass([
                  'hover:bg-gray-50 transition-colors',
                  isSelected(item) ? 'bg-green-50' : ''
                ])
                    }, [
                      _createElementVNode("td", _hoisted_32, [
                        _createElementVNode("input", {
                          type: "checkbox",
                          checked: isSelected(item),
                          onChange: ($event: any) => (toggleSelection(item)),
                          disabled: _unref(isPending),
                          class: "w-4 h-4 rounded border-gray-300 text-green-600 focus:ring-green-500"
                        }, null, 40, _hoisted_33)
                      ]),
                      _createElementVNode("td", _hoisted_34, [
                        _createElementVNode("span", _hoisted_35, _toDisplayString(item?.scheme_code), 1)
                      ]),
                      _createElementVNode("td", _hoisted_36, [
                        _createElementVNode("span", _hoisted_37, _toDisplayString(item?.option_code), 1),
                        _createElementVNode("small", _hoisted_38, _toDisplayString(item?.option_name), 1)
                      ]),
                      _createElementVNode("td", _hoisted_39, [
                        _createElementVNode("span", _hoisted_40, _toDisplayString(item?.membership_number), 1)
                      ]),
                      _createElementVNode("td", _hoisted_41, [
                        _createElementVNode("span", _hoisted_42, _toDisplayString(item?.health_seeker?.first_name) + " " + _toDisplayString(item?.health_seeker?.middle_name), 1)
                      ]),
                      _createElementVNode("td", _hoisted_43, [
                        _createElementVNode("span", _hoisted_44, _toDisplayString(item?.health_seeker?.surname), 1)
                      ]),
                      _createElementVNode("td", _hoisted_45, [
                        _createElementVNode("span", _hoisted_46, _toDisplayString(item.dependant_code), 1)
                      ]),
                      _createElementVNode("td", _hoisted_47, [
                        _createElementVNode("span", _hoisted_48, _toDisplayString(item?.programme_phase), 1)
                      ]),
                      _createElementVNode("td", _hoisted_49, [
                        _createElementVNode("div", _hoisted_50, [
                          _createElementVNode("div", _hoisted_51, _toDisplayString(item?.auth_start_date), 1),
                          _createElementVNode("div", _hoisted_52, "to " + _toDisplayString(item?.auth_end_date), 1)
                        ])
                      ]),
                      _createElementVNode("td", _hoisted_53, [
                        _createElementVNode("div", _hoisted_54, [
                          _createElementVNode("span", null, _toDisplayString(item?.sunset), 1),
                          _cache[31] || (_cache[31] = _createElementVNode("span", { class: "text-gray-400" }, "→", -1)),
                          _createElementVNode("span", null, _toDisplayString(item?.to_year), 1)
                        ])
                      ]),
                      _createElementVNode("td", _hoisted_55, [
                        _createElementVNode("div", _hoisted_56, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item?.tariff_codes, (code) => {
                            return (_openBlock(), _createElementBlock("span", {
                              key: code,
                              class: _normalizeClass([
                        'inline-flex items-center px-2 py-0.5 rounded text-xs font-medium',
                        isSelected(item) 
                          ? 'bg-green-100 text-green-800' 
                          : 'bg-slate-200 text-slate-900'
                      ])
                            }, _toDisplayString(code), 3))
                          }), 128))
                        ])
                      ]),
                      _createElementVNode("td", _hoisted_57, [
                        _createElementVNode("button", {
                          onClick: ($event: any) => (openTreatmentPlanDialog(item)),
                          class: "inline-flex items-center justify-center gap-1 py-1 px-2 border border-sky-900 text-[#225f7a] hover:bg-slate-200 rounded-lg transition-colors",
                          title: "View Treatment Plan"
                        }, [
                          _createVNode(_unref(Eye), { class: "h-5 w-5 tshaks" }),
                          _cache[32] || (_cache[32] = _createTextVNode(" Treatment ", -1))
                        ], 8, _hoisted_58)
                      ])
                    ], 2))
                  }), 128))
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_59, [
            _createElementVNode("div", _hoisted_60, " Showing " + _toDisplayString(((currentPage.value - 1) * itemsPerPage.value) + 1) + " to " + _toDisplayString(Math.min(currentPage.value * itemsPerPage.value, filteredData.value.length)) + " of " + _toDisplayString(filteredData.value.length) + " results ", 1),
            _createElementVNode("div", _hoisted_61, [
              _createVNode(_unref(Button), {
                size: "sm",
                variant: "outline",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (goToPage(currentPage.value - 1))),
                disabled: currentPage.value === 1
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(ChevronLeft), { class: "h-4 w-4" }),
                  _cache[33] || (_cache[33] = _createTextVNode(" Previous ", -1))
                ]),
                _: 1
              }, 8, ["disabled"]),
              _createElementVNode("div", _hoisted_62, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(totalPages.value, (page) => {
                  return _withDirectives((_openBlock(), _createBlock(_unref(Button), {
                    key: page,
                    size: "sm",
                    variant: page === currentPage.value ? 'default' : 'outline',
                    onClick: ($event: any) => (goToPage(page)),
                    class: "min-w-[40px]"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(page), 1)
                    ]),
                    _: 2
                  }, 1032, ["variant", "onClick"])), [
                    [_vShow, page === 1 || page === totalPages.value || Math.abs(page - currentPage.value) <= 1]
                  ])
                }), 128))
              ]),
              _createVNode(_unref(Button), {
                size: "sm",
                variant: "outline",
                onClick: _cache[6] || (_cache[6] = ($event: any) => (goToPage(currentPage.value + 1))),
                disabled: currentPage.value === totalPages.value
              }, {
                default: _withCtx(() => [
                  _cache[34] || (_cache[34] = _createTextVNode(" Next ", -1)),
                  _createVNode(_unref(ChevronRight), { class: "h-4 w-4" })
                ]),
                _: 1
              }, 8, ["disabled"])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (!_unref(isLoading) && !_unref(isError) && filteredData.value.length === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
          _cache[37] || (_cache[37] = _createElementVNode("svg", {
            class: "h-24 w-24 text-gray-300 mb-4",
            fill: "none",
            viewBox: "0 0 24 24",
            stroke: "currentColor"
          }, [
            _createElementVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "1.5",
              d: "M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 006.586 13H4"
            })
          ], -1)),
          _createElementVNode("h3", _hoisted_64, _toDisplayString(searchQuery.value ? 'No Results Found' : 'No Health Seekers Found'), 1),
          _createElementVNode("p", _hoisted_65, _toDisplayString(searchQuery.value 
          ? `No health seekers match "${searchQuery.value}"` 
          : 'There are no eligible health seekers for rollover at this time.'), 1),
          (searchQuery.value)
            ? (_openBlock(), _createBlock(_unref(Button), {
                key: 0,
                onClick: _cache[7] || (_cache[7] = ($event: any) => (searchQuery.value = '')),
                variant: "outline"
              }, {
                default: _withCtx(() => [...(_cache[35] || (_cache[35] = [
                  _createTextVNode(" Clear Search ", -1)
                ]))]),
                _: 1
              }))
            : (_openBlock(), _createBlock(_unref(Button), {
                key: 1,
                onClick: _cache[8] || (_cache[8] = ($event: any) => (_unref(refetch)())),
                variant: "outline"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(RepeatIcon), { class: "mr-2 h-4 w-4" }),
                  _cache[36] || (_cache[36] = _createTextVNode(" Refresh ", -1))
                ]),
                _: 1
              }))
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})